import styled from 'styled-components'

export const DefaultText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  p {
    font-style: italic;
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    color: ${props => props.theme.colors.text.subtle};
    margin: ${props => props.theme.spacing.sp8} 0;
  }
`
